export default "__VITE_ASSET__NoGbNDgw__"